import { useAppSelector } from '../../../../store/hooks'
import { useActions } from '../../../../store/use-actions'
import { actions as rawActions } from '../../state/strategy-slice'
import { RiskManagedEditorDumb } from './dumb'

export const RiskManagedEditor = () => {
  const state = useAppSelector(state => state.strategy.selectedStrategy.riskManaged)
  const commonState = useAppSelector(state => state.strategy)
  const actions = useActions(rawActions)

  return (
    <RiskManagedEditorDumb
      assets={commonState.protectionAssets}
      errors={commonState.errors}
      fees={state.fees}
      isGeneratingCharts={
        commonState.isGeneratingPerformanceChart || commonState.isGeneratingProjectionChart
      }
      maxVolatility={state.targetVolatility.max}
      minVolatility={state.targetVolatility.min}
      selectedAsset={state.protectionAsset as any}
      targetVolatility={state.targetVolatility.value}
      onChangeTargetVolatility={v => actions.setRiskManagedTargetVolatility(Number(v))}
      onInspectAsset={asset => actions.inspectAsset(asset)}
      onSelectAsset={asset => actions.setRiskManagedProtectionAsset(asset)}
    />
  )
}
